import { all } from 'redux-saga/effects'

import { bankUsersRootSaga } from '../state/bank-users-slice'

export function* rootSaga() {
  yield all([bankUsersRootSaga()])
}
